module.exports = __webpack_public_path__ + "img/walletBox32.ee5ce6d8.png";